'use-client';
import * as React from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import type { IResponsivePopupContainerProps } from '../ResponsivePopupContainer.types';
import style from './style/ResponsivePopupContainer.scss';
import ResponsiveContainer from '@wix/thunderbolt-elements/components/ResponsiveContainer';
import { TestIds } from '../constants';
import semanticClassNames from '../ResponsivePopupContainer.semanticClassNames';
import { useEffect } from 'react';
import { PopupPageContext } from '../../ResponsivePopupPage/viewer/ResponsivePopupPageContext';

const ResponsivePopupContainer: React.FC<
  IResponsivePopupContainerProps
> = props => {
  const {
    id,
    className,
    customClassNames = [],
    containerProps,
    containerRootClassName,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    setSiteScrollingBlocked,
    isDocumentScrollEnabled,
    lang,
    withOverlay = false,
  } = props;

  const { onOverlayClick } = React.useContext(PopupPageContext);

  useEffect(() => {
    if (isDocumentScrollEnabled) {
      return;
    }

    setSiteScrollingBlocked(true, id);
    return () => setSiteScrollingBlocked(false, id);
  }, [id, isDocumentScrollEnabled, setSiteScrollingBlocked]);

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, containerRootClassName, style.root, {
        [style.withOverlay]: withOverlay,
      })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-block-level-container="PopupContainer"
      lang={lang}
    >
      {withOverlay && (
        <div
          className={style.overlay}
          onClick={onOverlayClick}
          data-testid={TestIds.ResponsivePopupContainerOverlay}
        ></div>
      )}
      <div
        className={classNames(
          style.bg,
          formatClassNames(semanticClassNames.root, ...customClassNames),
        )}
        data-testid={TestIds.ResponsivePopupContainerBg}
      />
      <ResponsiveContainer {...containerProps}>{children}</ResponsiveContainer>
    </div>
  );
};

export default ResponsivePopupContainer;
